import _Object$assign from 'babel-runtime/core-js/object/assign';
import _createClass from 'babel-runtime/helpers/createClass';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import 'reflect-metadata';
import React from 'react';
import mapValues from 'lodash/mapValues';
import find from 'lodash/find';
import hoistNonReactStatics from 'hoist-non-react-statics';
import MessageBusTransport from '@central-products/message-transport-bus';
import isSSR from './isSSR';

var firstToUpperCase = function firstToUpperCase(letters) {
  return letters.replace(/(?:^|\s)(\w)/g, function (matches, letter) {
    return letter.toUpperCase();
  });
};

var toUpperCamelCase = function toUpperCamelCase(someText) {
  return someText.split('.').map(firstToUpperCase).join('');
};

export var SERVICE_METADATA_KEY = 'service';
// disable babel runtime polyfill

var _ref = global || window,
    Reflect = _ref.Reflect;

export default (function (TransportInterface, methodsImplementation) {
  return function (WrappedComponent) {
    var _class2, _temp2, _initialiseProps;

    var interfaceMetadata = Reflect.getMetadata(SERVICE_METADATA_KEY, new TransportInterface());

    var AbstractComponentService = function (_TransportInterface) {
      _inherits(AbstractComponentService, _TransportInterface);

      function AbstractComponentService(methods, transport) {
        _classCallCheck(this, AbstractComponentService);

        var _this = _possibleConstructorReturn(this, (AbstractComponentService.__proto__ || _Object$getPrototypeOf(AbstractComponentService)).call(this));

        _this.notifiers = {};

        _Object$keys(methods).filter(function (key) {
          return find(interfaceMetadata.methods, { property: key });
        }).forEach(function (key) {
          _this[key] = function (eventData) {
            return methods[key](eventData, _this.notifiers);
          };
        });

        interfaceMetadata.events.forEach(function (event) {
          _this[event.property] = function (notifier) {
            _this.notifiers['notify' + toUpperCamelCase(event.name)] = notifier;
          };
        });
        // FixMe: not sure about MessageBusTransport should be injected.
        _this.transport = (transport || MessageBusTransport.getInstance()).bind(_this);
        return _this;
      }

      return AbstractComponentService;
    }(TransportInterface);

    var ConnectTransport = (_temp2 = _class2 = function (_React$Component) {
      _inherits(ConnectTransport, _React$Component);

      function ConnectTransport() {
        var _ref2;

        var _temp, _this2, _ret;

        _classCallCheck(this, ConnectTransport);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = ConnectTransport.__proto__ || _Object$getPrototypeOf(ConnectTransport)).call.apply(_ref2, [this].concat(args))), _this2), _initialiseProps.call(_this2), _temp), _possibleConstructorReturn(_this2, _ret);
      }

      _createClass(ConnectTransport, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
          if (!isSSR) {
            this.transportService = new AbstractComponentService(this.methods);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // FixMe: not sure about MessageBusTransport should be injected.
          if (this.transportService) {
            var transport = MessageBusTransport.getInstance();
            transport.unbind(this.transportService);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var notifiers = this.transportService ? this.transportService.notifiers : {};
          return React.createElement(WrappedComponent, _Object$assign({}, this.props, notifiers));
        }
      }]);

      return ConnectTransport;
    }(React.Component), _class2.WrappedComponent = WrappedComponent, _class2.displayName = 'implements' + toUpperCamelCase(interfaceMetadata.serviceName) + 'Service(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _initialiseProps = function _initialiseProps() {
      var _this3 = this;

      this.methods = mapValues(methodsImplementation, function (createMethod) {
        return function () {
          var method = createMethod(_this3.props);
          return method.apply(undefined, arguments);
        };
      });
    }, _temp2);

    return hoistNonReactStatics(ConnectTransport, WrappedComponent);
  };
});